import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Card, Space, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import { pushToLogin } from '~/api/axios';
import { useInvitationPageState } from '~/hooks/invitation';

const { Title, Text } = Typography;

const NeedLoginCase: FC<RouteComponentProps> = (props) => {
  const { history } = props;

  const [pageState] = useInvitationPageState();

  const businessName = pageState.data?.businessLegalName;
  const email = pageState.data.emailAddress;

  const goAuth = () => {
    const path = history.location.pathname + history.location.search;
    pushToLogin(path);
  };

  const { t } = useTranslation('invitation');

  return (
    <Card className="Invitation-Card">
      <Title className="Invitation-Title" level={2}>
        {t('translation:businessPortal').toUpperCase()}
      </Title>
      <Text type="secondary" className="Invitation-TextSignIn">
        <Trans
          ns="invitation"
          defaults="You have been invited to <strong>{{businessName}}</strong> company as <strong>{{email}}</strong>. You need to log in first to accept the invitation"
          values={{
            businessName,
            email,
          }}
        />
      </Text>
      <Space direction="vertical" style={fullWidth}>
        <Button onClick={goAuth} type="primary" size="large" style={fullWidth}>
          {t('Go to log in')}
        </Button>
      </Space>
    </Card>
  );
};

const fullWidth = { width: '100%' };

export default NeedLoginCase;
